interface FightKeys {
  [key: string]: string;
}

const keys: FightKeys = {
  5: 'standing',
  7: 'standing',
  4: 'fence',
  8: 'fence',
  3: 'ground',
  9: 'ground',
};

const wrestlingKeys: FightKeys = {
  5: 'standing',
  7: 'standing',
  4: 'riding',
  8: 'riding',
  3: 'ground',
  9: 'ground',
};

const grapplingKeys: FightKeys = {
  5: 'standing',
  7: 'standing',
  3: 'ground',
  9: 'ground',
};

export const fightKeys = keys;
export const fightKeysWrestling = wrestlingKeys;
export const fightKeysGrappling = grapplingKeys;

export const redCornerDomainKeys = ['3', '4', '5'];
export const blueCornerDomainKeys = ['7', '8', '9'];
export const domainKeys = ['5', '4', '3', '9', '8', '7'];

export function getDomainStanceKeys(fightType: string): FightKeys {
  if (fightType === 'WRESTLING') return wrestlingKeys;
  if (fightType === 'SUBMISSION_GRAPPLING') return grapplingKeys;
  return keys;
}

export function cornerOfDomainKey(
  domainKey: string | null | undefined,
): 'red' | 'blue' | null {
  if (!domainKey) return null;
  if (redCornerDomainKeys.includes(domainKey)) return 'red';
  if (blueCornerDomainKeys.includes(domainKey)) return 'blue';
  return null;
}

export function domainKeyFor(
  fightType: string,
  corner: string | null | undefined,
  stance: string | null | undefined,
): string | null {
  if (!stance || (corner !== 'red' && corner !== 'blue')) return null;

  const table = getDomainStanceKeys(fightType);
  const cornerKeys =
    corner === 'red' ? redCornerDomainKeys : blueCornerDomainKeys;

  return cornerKeys.find((key) => table[key] === stance) || null;
}
